import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

  import config from  '../../../config';


class AdminPromoCodesListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []

        menuItemsMap.push({onClick: 'editRecord', label: 'Edit'})

        if (!row.Deleted) {
            menuItemsMap.push({onClick: 'showRemoveDialog', label: 'Delete'})
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    editRecord(row) {
        this.props.editRecord(row);
    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }








    render() {
        //      console.log('state', this.state  );
        return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.adminPromoCodes.data} ref='table'
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="45px" dataAlign="center" dataField='Code'
                                       dataSort={true}>Code</TableHeaderColumn>


                    <TableHeaderColumn width="45px" dataAlign="center" dataField='Percent'
                                            dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Percent'] , format: (value, arg2) => {
                            return value == '' ? '': value  + '%'
                        }
                    }} editable={ false } dataSort={true}>Percent</TableHeaderColumn>
                    <TableHeaderColumn width="45px" dataAlign="center" dataField='Amount'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Amount'] , format: (value, arg2) => {
                            if (_.isObject(value)){
                                return  JSON.stringify(value)
                            } else {
                                return value == '' ? '' : value + '$'
                            }
                        }
                    }} editable={ false } dataSort={true}>Amount</TableHeaderColumn>
                    <TableHeaderColumn width="45px" dataAlign="center" dataField='SellerPayout'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['SellerPayout'] , format: (value, arg2) => {
                            return value == '' ? '':   value  + '%'
                        }
                    }} editable={ false } dataSort={true}>Seller Payout</TableHeaderColumn>
                     <TableHeaderColumn width="40px" dataField="expiredAt" dataAlign="center"
                                       dataFormat={ dateFormatter }

                                       formatExtraData={ {'name': 'expiredAt', 'format': 'YYYY-MM-DD'} }
                                       dataSort={true}>Expired At</TableHeaderColumn>

                    <TableHeaderColumn width="45px" dataAlign="center" dataField='ErrorMessage'
                                       dataSort={true}>Error Message</TableHeaderColumn>
                    <TableHeaderColumn width="45px" dataAlign="center" dataField='Condition'
                                       columnClassName={'break-word'}      dataFormat={ customFormatter } formatExtraData={ {
                        path: ['PromoCodeData'] , format: (value, arg2) => {
                            console.log('value', value  );
                            return value == '' ? '':  JSON.stringify(value)
                        }
                    }} dataSort={true}>Data</TableHeaderColumn>
                    <TableHeaderColumn width="45px" dataAlign="center" dataField='Condition'
                                       columnClassName={'break-word'}      dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Condition'] , format: (value, arg2) => {
                            return value == '' ? '':  JSON.stringify(value)
                        }
                    }} dataSort={true}>Conditions</TableHeaderColumn>




                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="20px" dataAlign="center" columnClassName={'actions-column'}
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default AdminPromoCodesListTable;
